import React, { useState } from 'react';
import { ShieldAlert, AlertTriangle, X } from 'lucide-react';
import { Instrument } from '../types/instruments';
interface OverrideConfirmationModalProps {
  instrument: Instrument;
  reason: string;
  notes: string;
  onConfirm: () => void;
  onCancel: () => void;
}
export function OverrideConfirmationModal({
  instrument,
  reason,
  notes,
  onConfirm,
  onCancel
}: OverrideConfirmationModalProps) {
  const [confirmText, setConfirmText] = useState('');
  const isValid = confirmText.toLowerCase() === instrument.name.toLowerCase();
  return <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-id="element-294">
      <div className="w-full max-w-lg bg-surface border border-border rounded-modal shadow-2xl overflow-hidden" data-id="element-295">
        <div className="bg-warning/10 border-b border-warning/30 p-6" data-id="element-296">
          <div className="flex items-center gap-3 mb-4" data-id="element-297">
            <div className="p-2 bg-warning rounded-input" data-id="element-298">
              <ShieldAlert className="w-6 h-6 text-white" data-id="element-299" />
            </div>
            <h2 className="text-xl font-bold text-text-primary" data-id="element-300">
              Confirm Override
            </h2>
          </div>
          <div className="flex items-start gap-2 bg-critical/10 border border-critical/30 rounded-input p-3" data-id="element-301">
            <AlertTriangle className="w-5 h-5 text-critical flex-shrink-0 mt-0.5" data-id="element-302" />
            <p className="text-sm text-text-secondary" data-id="element-303">
              This action will be permanently logged in the audit trail and
              cannot be undone.
            </p>
          </div>
        </div>

        <div className="p-6" data-id="element-304">
          <div className="bg-surface-2 rounded-card p-4 mb-6 border border-border" data-id="element-305">
            <div className="text-sm text-text-secondary mb-2 uppercase tracking-wide font-bold" data-id="element-306">
              Override Summary
            </div>
            <div className="space-y-2 text-sm" data-id="element-307">
              <div className="flex justify-between" data-id="element-308">
                <span className="text-text-secondary" data-id="element-309">Instrument:</span>
                <span className="text-text-primary font-bold" data-id="element-310">
                  {instrument.name}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-311">
                <span className="text-text-secondary" data-id="element-312">Slot:</span>
                <span className="text-text-primary font-mono" data-id="element-313">
                  {instrument.slot}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-314">
                <span className="text-text-secondary" data-id="element-315">Reason:</span>
                <span className="text-text-primary" data-id="element-316">{reason}</span>
              </div>
              <div className="pt-2 border-t border-border" data-id="element-317">
                <span className="text-text-secondary" data-id="element-318">Notes:</span>
                <p className="text-text-primary mt-1" data-id="element-319">{notes}</p>
              </div>
            </div>
          </div>

          <div className="mb-6" data-id="element-320">
            <label className="block text-sm font-bold text-text-primary mb-2 uppercase tracking-wide" data-id="element-321">
              Type instrument name to confirm
            </label>
            <input type="text" value={confirmText} onChange={e => setConfirmText(e.target.value)} placeholder={instrument.name} className="w-full bg-surface-2 border border-border rounded-input px-4 py-3 text-text-primary placeholder-text-secondary focus:ring-2 focus:ring-warning focus:border-transparent" data-id="element-322" />
            {confirmText && !isValid && <p className="text-xs text-critical mt-1" data-id="element-323">
                Name does not match. Please type exactly: {instrument.name}
              </p>}
          </div>

          <div className="flex gap-3" data-id="element-324">
            <button onClick={onCancel} className="flex-1 px-4 py-3 bg-surface-2 hover:bg-surface text-text-primary border border-border rounded-input font-bold transition-colors" data-id="element-325">
              Cancel
            </button>
            <button onClick={onConfirm} disabled={!isValid} className={`flex-1 px-4 py-3 rounded-input font-bold transition-all ${isValid ? 'bg-warning hover:bg-yellow-500 text-white' : 'bg-surface-2 text-text-secondary cursor-not-allowed border border-border'}`} data-id="element-326">
              Confirm Override
            </button>
          </div>
        </div>
      </div>
    </div>;
}